import { Modal, ModalBody } from '@/components/ui/modal';
import SchoolSelector from '../../SchoolSelector';

interface FreeOraModalProps {
  open: boolean;
  schoolName?: string;
  onClose: () => void;
  onRequestToJoin: () => void;
  canRequestToJoin: boolean;
}

const FreeOraModal: React.FC<FreeOraModalProps> = ({
  open,
  schoolName,
  onClose,
  onRequestToJoin,
  canRequestToJoin,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      name="free-ora"
      blurs={false}
      className="modal--glass"
    >
      <ModalBody className="modal_content">
        <h2>
          <span className="eyebrow">Become an</span>
          <span>Ora Ambassador</span>
        </h2>
        <p>
          Help bring Ora to <strong>{schoolName ?? 'your school'}</strong> and
          get Ora <strong>free for one year.</strong>
        </p>
        <SchoolSelector showAddSchoolOption={false} />
        <button
          className="button"
          onClick={onRequestToJoin}
          disabled={!canRequestToJoin}
        >
          Request to Join
        </button>
        <div className="blur-purple"></div>
        <div className="blur-pink"></div>
      </ModalBody>
    </Modal>
  );
};

export default FreeOraModal;
